import { render, staticRenderFns } from "./TxInteractive.vue?vue&type=template&id=5c5d98ed&scoped=true&"
import script from "./TxInteractive.vue?vue&type=script&lang=ts&"
export * from "./TxInteractive.vue?vue&type=script&lang=ts&"
import style0 from "./TxInteractive.vue?vue&type=style&index=0&id=5c5d98ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5d98ed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCol,VProgressCircular})
